// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AiProposalFailureBanner_AiProposalFragmentDoc } from './AiProposalFailureBanner.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffsTabAiProposalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type TakeoffsTabAiProposalQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, progressText?: string | null | undefined, failureReason?: string | null | undefined, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, workflow?: { __typename?: 'PlanPackageAiProposalWorkflowDetail', code: Types.PlanPackageAiProposalWorkflow } | null | undefined } | null | undefined } };

export type PlanPackageTakeoffsV2_AiProposalFragment = { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, progressText?: string | null | undefined, failureReason?: string | null | undefined, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, workflow?: { __typename?: 'PlanPackageAiProposalWorkflowDetail', code: Types.PlanPackageAiProposalWorkflow } | null | undefined } | null | undefined };

export const PlanPackageTakeoffsV2_AiProposalFragmentDoc = gql`
    fragment PlanPackageTakeoffsV2_AiProposal on PlanPackage {
  id
  aiProposal {
    id
    status {
      code
    }
    ...AiProposalFailureBanner_AiProposal
    progressText
  }
}
    ${AiProposalFailureBanner_AiProposalFragmentDoc}`;
export const TakeoffsTabAiProposalDocument = gql`
    query TakeoffsTabAiProposal($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageTakeoffsV2_AiProposal
  }
}
    ${PlanPackageTakeoffsV2_AiProposalFragmentDoc}`;

/**
 * __useTakeoffsTabAiProposalQuery__
 *
 * To run a query within a React component, call `useTakeoffsTabAiProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffsTabAiProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffsTabAiProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useTakeoffsTabAiProposalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables> & ({ variables: TakeoffsTabAiProposalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>(TakeoffsTabAiProposalDocument, options);
      }
export function useTakeoffsTabAiProposalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>(TakeoffsTabAiProposalDocument, options);
        }
// @ts-ignore
export function useTakeoffsTabAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>;
export function useTakeoffsTabAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsTabAiProposalQuery | undefined, TakeoffsTabAiProposalQueryVariables>;
export function useTakeoffsTabAiProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>(TakeoffsTabAiProposalDocument, options);
        }
export type TakeoffsTabAiProposalQueryHookResult = ReturnType<typeof useTakeoffsTabAiProposalQuery>;
export type TakeoffsTabAiProposalLazyQueryHookResult = ReturnType<typeof useTakeoffsTabAiProposalLazyQuery>;
export type TakeoffsTabAiProposalSuspenseQueryHookResult = ReturnType<typeof useTakeoffsTabAiProposalSuspenseQuery>;
export type TakeoffsTabAiProposalQueryResult = ApolloReactCommon.QueryResult<TakeoffsTabAiProposalQuery, TakeoffsTabAiProposalQueryVariables>;